const configuredPublicUrl = import.meta.env.VITE_PUBLIC_SITE_URL?.replace(/\/+$/, '') ?? '';

export function publicOrigin() {
  return configuredPublicUrl;
}

export function hasPublicSiteUrl() {
  return Boolean(configuredPublicUrl);
}

export function publicFileUrl(slug: string) {
  return configuredPublicUrl ? `${configuredPublicUrl}/catalog/${slug}` : '';
}

export function localFilePath(slug: string) {
  return `/catalog/${slug}`;
}
